/* eslint-disable react/prop-types */
import React, { memo } from 'react';

import { getColor } from './utils';

function Slash({ coordinates: [ y, x ], WinningHand, style, className, gameId }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1"
      height="1"
      x={x}
      y={y}
      style={style}
      className={className}
      data-winner={WinningHand}
    >
      <rect
        x="2"
        y="10.5"
        width="20"
        height="3"
        transform="translate(-5 12) rotate(-45)"
        fill={getColor(gameId, WinningHand)}
      />
    </svg>
  );
}

export default memo(Slash);
